{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Facility Header",
      "width": 130,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "petrinex_facility_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Petrinex ID",
      "folder": "Facility Header",
      "width": 140,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "license_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Number",
      "folder": "Facility Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Facility Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Name",
      "folder": "Facility Header",
      "width": 225,
      "isShownByDefault": true,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "folder": "Facility Header",
      "width": 200,
    },
  },
  "operator": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Operator",
      "folder": "Facility Header",
      "width": 250,
      "isShownByDefault": true,
    },
  },
  "type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Type",
      "folder": "Facility Header",
      "width": 175,
      "isShownByDefault": true,
    },
  },
  "subtype": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Subtype",
      "folder": "Facility Header",
    },
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Abandoned",
        "Active",
        "Amended",
        "COR",
        "Cancelled",
        "Constructed",
        "Construction Completed",
        "Decommissioned",
        "Issued",
        "Inactive",
        "Ministry Suspended",
        "New",
        "Non-Reporting",
        "Operating",
        "Permit Approved",
        "Proposed",
        "RecCertified",
        "RecExempt",
        "Removed",
        "Retired",
        "Suspended",
        "Under Construction",
      ],
    },
    "ui": {
      "label": "Op Status",
      "folder": "Facility Header",
      "isShownByDefault": true,
    },
  },
  "license_status": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Abandoned",
        "Amended",
        "Cancelled",
        "Decommission",
        "Issued",
        "Re-Entered",
        "RecCertified",
        "RecExempt",
        "Suspended",
        "Suspension",
      ],
    },
    "ui": {
      "label": "Licence Status",
      "folder": "Facility Header",
    },
  },
  "license_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Date",
      "folder": "Facility Header",
      "width": 110,
    },
  },
  "symbol_name": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Facility",
        "Minor Facility",
        "Pipe/Meter",
        "Plant",
        "Pump/Compressor",
        "Tanks",
      ],
    },
    "ui": {
      "label": "Symbol",
      "folder": "Facility Header",
    },
  },
  "has_production": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Production",
      "folder": "Facility Header",
      "isShownByDefault": true,
    },
  },
  "has_produced_in_last_three_months": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Produced In Last 3 mos",
      "folder": "Facility Header",
    },
  },
  "has_complaint": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Complaint",
      "folder": "Facility Header",
    },
  },
  "has_spill": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Spill",
      "folder": "Facility Header",
    },
  },
  "surface_location": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Surface DLS/NTS",
      "folder": "Location",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "surface_latitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Latitude",
      "folder": "Location",
    },
  },
  "surface_longitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Longitude",
      "folder": "Location",
    },
  },
  "capacity_rec_sales_gas_e3m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Sales Gas Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_raw_gas_e3m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Raw Gas Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_c2_m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "C2 Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_c2_mix_m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "C2 Mix Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_c3_m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "C3 Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_c4_m3_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "C4 Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_sulphur_inlet": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Sulphur Inlet Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_sulphur_recovered": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Sulphur Recovered Capacity",
      "folder": "Capacity",
    },
  },
  "capacity_sulphur_emmission": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Sulphur Emmission Capacity",
      "folder": "Capacity",
    },
  },
  "recent_rec_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Gas Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_rec_litemx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Lite Mix Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_rec_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Water Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_rec_sulphur": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Last Month Sulphur Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_nc5_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month NC5-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_n2_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month N2 Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_steam_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Steam Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_freshwater_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Freshwater Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_ic4_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month IC4-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c6_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C6-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c2_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C2-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c4_sp_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C4-SP Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_co2_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month CO2 Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_helium_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Helium Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_cond_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Cond Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c3_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C3-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c1_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C1-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_entgas_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Entgas Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_sprill_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Last Month Sprill Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_nc4_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month NC4-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c4_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C4-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c5_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C5-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_water_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Water Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c5_sp_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C5-SP Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_brkwtr_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Brkwtr Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_syncrd_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Syncrd Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_waste_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Waste Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_co2_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month CO2-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_ic5_mx_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month IC5-MX Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_c3_sp_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C3-SP Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_oil_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Oil Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_acgas_rec": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Acgas Rec",
      "folder": "Production Receipt",
    },
  },
  "recent_disp_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Gas Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c1_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C1 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c2_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C2 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c3_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C3 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_ic4_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month iC4 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_nc4_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month nC4 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_ic5_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month iC5 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_nc5_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month nC5 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c6_mx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C6 Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c2_sp": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C2 Spec Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c3_sp": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C3 Spec Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c4_sp": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C4 Spec Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_c5_sp": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month C5 Spec Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_cond": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Condensate Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_sulphur": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonnes/d",
    },
    "ui": {
      "label": "Last Month Sulphur Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_acgas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Acid Gas Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Oil Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Water Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_disp_litemx": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Month Lite Mix Disp",
      "folder": "Production Disposition",
    },
  },
  "recent_fuel_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Fuel Gas",
      "folder": "Production Summary",
    },
  },
  "recent_flare_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Flared Gas",
      "folder": "Production Summary",
    },
  },
  "recent_flare_acgas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Flared Acid Gas",
      "folder": "Production Summary",
    },
  },
  "recent_vent_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Vent Gas",
      "folder": "Production Summary",
    },
  },
  "recent_diff_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Month Diff Gas",
      "folder": "Production Summary",
    },
  },
  "recent_production_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Month Production Date",
      "folder": "Production Summary",
    },
  },
  "facility_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "symbol": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "font": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
